// Mock data for Newcon Roofing & Ceiling website

export const COMPANY = {
  name: "NRC",
  brand: "Newcon Roofing & Ceiling",
  tagline: "Roofing & Ceiling Specialists.",
  shortName: "Newcon",
  fullName: "Newcon Roofing & Ceiling",
  established: 2008,
  experienceYears: 17,
  phone: "+91 91632 14494",
  altPhone: "+91 91632 14494",
  email: "info@newcon.in",
  salesEmail: "sales@newcon.in",
  address: "5/1 Dakshin Para Road, Kolkata, West Bengal 700028",
  hours: "Mon - Sat, 9:30 AM - 7:00 PM",
  hunterPartner: true,
  logoUrl: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/vonvgmy0_WhatsApp%20Image%202026-05-26%20at%203.32.52%20PM.jpeg",
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    youtube: "#"
  }
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Clients", href: "#clients" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" }
];

export const HERO_SLIDES = [
  {
    id: 1,
    eyebrow: "Roofing & Ceiling Specialists",
    title: "Strong Roofs. Smart Ceilings.",
    subtitle: "End-to-end metal roofing, cladding and ceiling solutions for India's most demanding projects.",
    image: "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzdGFuZGluZyUyMHNlYW0lMjByb29maW5nfGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    eyebrow: "Hunter Douglas Authorised Partner",
    title: "World-Class Ceiling Systems.",
    subtitle: "Authentic Hunter Douglas linear, baffle and acoustic ceilings engineered for Indian climates.",
    image: "https://images.pexels.com/photos/9305406/pexels-photo-9305406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    eyebrow: "Under Deck Insulation",
    title: "Cooler Spaces. Lower Bills.",
    subtitle: "Acoustic and thermal under-deck insulation that performs for decades.",
    image: "https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxyb29mJTIwaW5zdWxhdGlvbnxlbnwwfHx8fDE3Nzk3OTU0ODZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    eyebrow: "Industrial Shed Roofing",
    title: "Built To Withstand It All.",
    subtitle: "Standing seam, trapezoidal & PEB roofing for warehouses and factories.",
    image: "https://images.unsplash.com/photo-1602064828974-fcac67d33f4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc2hlZCUyMHJvb2Z8ZW58MHx8fHwxNzc5Nzk1NDcxfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    eyebrow: "False Ceilings & Acoustic Systems",
    title: "Interiors That Inspire.",
    subtitle: "Gypsum, metal, baffle and bespoke acoustic ceiling systems.",
    image: "https://images.unsplash.com/photo-1582203423341-64b918240e25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxneXBzdW0lMjBjZWlsaW5nJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85"
  }
];

export const FEATURES = [
  {
    icon: "HardHat",
    title: "Certified Crew",
    text: "Trained roofing and ceiling installers, in-house engineers and project managers ensure on-spec delivery on every site."
  },
  {
    icon: "ShieldCheck",
    title: "Original Materials",
    text: "Authorised distributor for Hunter Douglas and other leading global brands. Zero compromise on source."
  },
  {
    icon: "Clock",
    title: "On-Time, Every Time",
    text: "Schedule-driven project execution. 24/7 site support and transparent reporting throughout."
  }
];

export const SERVICES = [
  {
    id: "metal-roofing",
    title: "Metal Roofing",
    desc: "Standing seam, trapezoidal and bare galvalume roofing systems for industrial sheds, warehouses and PEB structures.",
    image: "https://images.unsplash.com/photo-1602193458517-db6caca8f1fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxzdGFuZGluZyUyMHNlYW0lMjByb29maW5nfGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85",
    icon: "Mountain",
    points: ["Standing seam profiles", "Trapezoidal sheeting", "PEB compatible"]
  },
  {
    id: "false-ceiling",
    title: "False Ceiling",
    desc: "Gypsum, calcium silicate, metal, mineral fibre and Hunter Douglas custom ceilings for corporate and retail spaces.",
    image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/9rj3rht8_WhatsApp%20Image%202026-05-26%20at%205.21.18%20PM.jpeg",
    icon: "LayoutPanelTop",
    points: ["Gypsum & metal", "Acoustic boards", "Hunter Douglas systems"]
  },
  {
    id: "under-deck-insulation",
    title: "Under Deck Insulation",
    desc: "Thermal and acoustic insulation for industrial sheds, factories and warehouses. Glass wool, rockwool, PUF and XLPE systems.",
    image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/uejti37b_WhatsApp%20Image%202026-05-26%20at%205.23.44%20PM.jpeg",
    icon: "Thermometer",
    points: ["Glass wool / Rockwool", "PUF & XLPE foam", "Acoustic & thermal"]
  },
  {
    id: "roof-cladding",
    title: "Roof & Wall Cladding",
    desc: "ACP, HPL, metal, terracotta and louver cladding systems. PEB roofing and standing seam profiles for exteriors.",
    image: "https://images.pexels.com/photos/5264825/pexels-photo-5264825.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Building2",
    points: ["ACP / HPL / Metal", "Standing seam roofing", "Sun control louvers"]
  },
  {
    id: "acoustic-ceiling",
    title: "Acoustic Ceilings",
    desc: "Baffle ceilings, perforated metal acoustic panels and high-NRC systems for auditoriums, offices and educational spaces.",
    image: "https://images.pexels.com/photos/9305408/pexels-photo-9305408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "AudioLines",
    points: ["Baffle ceilings", "Perforated metal", "High NRC rating"]
  },
  {
    id: "baffle-ceiling",
    title: "Baffle Ceiling",
    desc: "Linear timber, metal and aluminium baffle ceiling systems for showrooms, lobbies, restaurants and modern offices. Custom finishes and span engineering.",
    image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/x4geqb2b_WhatsApp%20Image%202026-05-26%20at%205.27.41%20PM.jpeg",
    icon: "Grid3x3",
    points: ["Timber & metal baffles", "Custom spans & finishes", "Linear design feature"]
  }
];

export const STATS = [
  { value: 480, suffix: "+", label: "Projects Delivered" },
  { value: 17, suffix: "+", label: "Years Experience" },
  { value: 220, suffix: "+", label: "Happy Clients" },
  { value: 95, suffix: "+", label: "Skilled Workforce" }
];

export const PROJECTS = [
  { id: 1, title: "Warehouse Standing Seam Roof", category: "Metal Roofing", image: "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxzdGFuZGluZyUyMHNlYW0lMjByb29maW5nfGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85" },
  { id: 2, title: "NTPC Barauni", category: "False/Cavity Floor", image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/i3tw15rt_WhatsApp%20Image%202026-05-26%20at%205.52.10%20PM.jpeg" },
  { id: 3, title: "IOCL Haldia", category: "Clip In Type Suspended Ceiling", image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/o8zavftq_WhatsApp%20Image%202026-05-26%20at%205.52.10%20PM%20%281%29.jpeg" },
  { id: 4, title: "IOCL Paradip", category: "Lay In Type Suspended Ceiling", image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/lb6hn0on_WhatsApp%20Image%202026-05-26%20at%205.52.10%20PM%20%282%29.jpeg" },
  { id: 5, title: "Industrial Shed Roofing Project", category: "Metal Roofing", image: "https://images.unsplash.com/photo-1602064828974-fcac67d33f4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc2hlZCUyMHJvb2Z8ZW58MHx8fHwxNzc5Nzk1NDcxfDA&ixlib=rb-4.1.0&q=85" },
  { id: 6, title: "South City Mall Kolkata", category: "84R Type Suspended Ceiling", image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/fh7buriv_WhatsApp%20Image%202026-05-26%20at%205.52.10%20PM%20%283%29.jpeg" },
  { id: 7, title: "IISCO BURNPUR", category: "84C Type Suspended Ceiling", image: "https://customer-assets.emergentagent.com/job_newcon-web/artifacts/wfl405ix_WhatsApp%20Image%202026-05-26%20at%206.53.35%20PM.jpeg" },
  { id: 8, title: "Hospital False Ceiling", category: "False Ceiling", image: "https://images.unsplash.com/photo-1582203423341-64b918240e25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxneXBzdW0lMjBjZWlsaW5nJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85" },
  { id: 9, title: "PEB Shed Cladding", category: "Roof & Cladding", image: "https://images.pexels.com/photos/5264825/pexels-photo-5264825.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" }
];

export const PROJECT_CATEGORIES = ["All", "Metal Roofing", "False Ceiling", "Acoustic Ceiling", "Baffle Ceiling", "Clip In Type Suspended Ceiling", "Lay In Type Suspended Ceiling", "84R Type Suspended Ceiling", "84C Type Suspended Ceiling", "False/Cavity Floor", "Under Deck Insulation"];

export const CLIENTS = [
  "IOCL", "BPCL", "POWERGRID", "HPCL", "Airport Authority", "DAE", "WBPDCL", "SAIL"
];

export const FAQS = [
  { q: "What services does Newcon Roofing & Ceiling offer?", a: "We specialise in metal roofing (standing seam, trapezoidal, PEB), false ceilings (gypsum, metal, acoustic), under-deck insulation, suspended grid ceilings, acoustic ceilings and roof & wall cladding for commercial, industrial and institutional projects." },
  { q: "Are you an authorised partner for Hunter Douglas?", a: "Yes. NRC is an authorised channel partner for Hunter Douglas in India, delivering authentic ceiling, facade and louver systems with full manufacturer warranty." },
  { q: "Do you provide turnkey roofing solutions?", a: "Absolutely. From design consultation, material selection and engineering drawings to procurement, installation and post-handover support — we handle every phase end-to-end." },
  { q: "Which materials do you use for under-deck insulation?", a: "We offer glass wool, rockwool, PUF, XLPE and Nitrile rubber based systems depending on the thermal performance, fire rating and acoustic requirements of your project." },
  { q: "Do you take residential projects?", a: "Our primary focus is commercial, industrial and institutional roofing and ceiling work. However, for premium residential and villa projects we do execute bespoke ceiling and roofing scopes." },
  { q: "How long does a typical project take?", a: "Lead time depends on scope and material. A typical 10,000 sq ft ceiling or roofing scope is delivered in 25–45 working days. We share a detailed Gantt plan with every order." },
  { q: "Do you provide warranty?", a: "Yes. Every installation carries a workmanship warranty of 12–24 months and material warranty as per OEM (Hunter Douglas and other brand-backed warranties)." },
  { q: "Which regions do you serve?", a: "We operate pan-India with active project teams across Delhi NCR, Mumbai, Bangalore, Hyderabad, Chennai, Pune, Kolkata and Ahmedabad." }
];

export const TESTIMONIALS = [
  { name: "Rohit Malhotra", role: "Project Director, DLF", text: "NRC delivered the entire roofing and ceiling scope on our commercial block ahead of schedule. The Hunter Douglas integration was flawless." },
  { name: "Anita Iyer", role: "Principal Architect, Studio Form", text: "Their attention to detail on metal roofing junctions and ceiling alignments is rare in the industry. Truly a finishing-first contractor." },
  { name: "Sandeep Rao", role: "GM Operations, Wipro", text: "From under-deck insulation to suspended ceilings, NRC managed multi-trade scope with zero disruption to our data hall commissioning." },
  { name: "Megha Banerjee", role: "Interior Designer", text: "We trust Newcon Roofing & Ceiling with every premium ceiling specification we issue. The site finish always matches the render." },
  { name: "Vivek Khanna", role: "PMC, Shapoorji Pallonji", text: "Disciplined site supervisors, clean drawings, prompt RA bills. Among the best roofing & ceiling vendors we deal with nationally." },
  { name: "Priya Deshmukh", role: "Facility Head, Infosys", text: "Their ceiling refurbishment of our Pune campus was completed in two weekends with zero downtime. Highly recommended." }
];

export const BLOGS = [
  { id: 1, title: "Choosing the Right Under Deck Insulation for Indian Climates", date: "15 Jun 2025", category: "Insulation", excerpt: "Glass wool vs. rockwool vs. XLPE — a practical guide for warehouse and factory owners looking to cut energy costs.", image: "https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxyb29mJTIwaW5zdWxhdGlvbnxlbnwwfHx8fDE3Nzk3OTU0ODZ8MA&ixlib=rb-4.1.0&q=85" },
  { id: 2, title: "Why Hunter Douglas Ceilings Set the Global Benchmark", date: "02 Jun 2025", category: "Ceilings", excerpt: "From Techstyle acoustic panels to Luxalon linear ceilings — what makes the system worth the spec.", image: "https://images.unsplash.com/photo-1667893310241-08bf719d6fce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxneXBzdW0lMjBjZWlsaW5nJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85" },
  { id: 3, title: "Standing Seam vs Trapezoidal Roofing — Which Is Right?", date: "24 May 2025", category: "Roofing", excerpt: "A practical comparison of the two most popular metal roofing profiles in Indian industrial construction.", image: "https://images.unsplash.com/photo-1602193458517-db6caca8f1fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxzdGFuZGluZyUyMHNlYW0lMjByb29maW5nfGVufDB8fHx8MTc3OTc5NTQ3MXww&ixlib=rb-4.1.0&q=85" }
];
